import React, { useCallback, useEffect, useState } from "react";
import "./style.css";
import InvoiceBlock from "./invoiceBlock";
import AccountBlock from "./accountBlock";
import InfiniteScroll from "react-infinite-scroller";
import { useDispatch, useSelector } from "react-redux";
import { getDashboardData } from "../../../store/actions/precog/accounting";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  
const ToBeAccountantBlock = ({invoices, dashboardNextUrlPaginate, selectedDocuments, setSelectedDocuments, allDocumentsSelected, setAllDocumentsSelected, goToDetail}) => {
  const dispatch = useDispatch();  
  const isEndedDashboardData = useSelector((state) => state.precog.dashboardData.status?.ended);
  const isGettingDashboardData = useSelector((state) => state.precog.dashboardData.status?.started);
  const [nextPageUrl, setNextPageUrl] = useState(null); // TODO nexpage arriva dal then della prima chiamata getDashboardData
  const [fetching, setFetching] = useState(false);

  useEffect(() => {  
    setNextPageUrl(dashboardNextUrlPaginate);    
  }, [dashboardNextUrlPaginate]);
  
  const fetchItems = useCallback(() => {        
    // !! qui dovrebbe entrare se e solo se nextPageUrl è popolato
    if (fetching) {
      return;
    }
    /** Evita di fare chiamate multiple in serie */
    setFetching(true);
    
    try {
      dispatch(getDashboardData(nextPageUrl)).then((res) => {                   
        /** TODO gestire il campo next nel caso lo passi il BE altrimenti ricavarlo qui */ 
        if (res?.data?._links?.next?.href) {          
          setNextPageUrl(res?.data?._links?.next?.href);
        } else {
          setNextPageUrl(null);
        }
        setTimeout(() => {
          setFetching(false);
        }, 500);        
	  });      
    } catch (err){    
      setFetching(false);
    } 
  },
  [fetching, nextPageUrl]);

  const hasMoreItems = !!nextPageUrl;
  
  const loader = (
    <div
      style={{ position: "sticky", top: "50vh", /* top: "64px", */
        backgroundColor: "rgba(256,256,256, 0.7)", 
        width: "calc(100% - 64px)",
        height: "calc(100% - 64px)",
        zIndex: 9,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center", fontSize: "32px", color: "#0090d1", left: "64px" }}
    >
      <FontAwesomeIcon icon={["far", "circle-notch"]} spin />
    </div>
  );
  return (
    <>
      
      <InfiniteScroll
        initialLoad={false}
        pageStart={1}
        loadMore={() => fetchItems()}
        hasMore={isEndedDashboardData && hasMoreItems}
        loader={isGettingDashboardData && loader}	    
	      threshold={130}
        useWindow={false}
        getScrollParent={() => document.getElementById("dbx-main-container")}
      >
        <div>
          {isGettingDashboardData && loader}
          <div style={{opacity: isGettingDashboardData ? 0.5 : 1}}>
            {invoices.map((inv, index) => {
		  return (
		   <div key={`invoices_${index}`} className="precog-toBeAccountant-block-container">
		      <InvoiceBlock
                    data={inv}	
                    index={index}	        
		        selectedDocuments={selectedDocuments}
		        setSelectedDocuments={setSelectedDocuments}
		        allDocumentsSelected={allDocumentsSelected}
		        setAllDocumentsSelected={setAllDocumentsSelected}
		      />
				 <AccountBlock data={inv} goToDetail={goToDetail}
                    index={index}	        
                    selectedDocuments={selectedDocuments}
                    setSelectedDocuments={setSelectedDocuments}
                    allDocumentsSelected={allDocumentsSelected}
                    setAllDocumentsSelected={setAllDocumentsSelected}
                  />
			 </div>
		  );
            })

            }
          </div>
        </div>
      </InfiniteScroll>
    </>
  );
};

export default ToBeAccountantBlock;
